<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/communication/communicationSet')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white mgt-20">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="设备编号">
          <el-input
            v-model="form.name"
            clearable
            placeholder="请输入设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="预警方式">
          <el-select v-model="form.way" clearable placeholder="全部">
            <el-option label="短信预警服务" value="1"></el-option>
            <el-option label="语音电话预警服务" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关闭时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮 -->
    <div class="flex aic mgt-20 mgb-20">
      <el-button class="mgr-20" @click="add">添加</el-button>
      <el-button @click="recover">恢复预警</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="warnType" label="预警类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.warnType == 1
                ? '设备离线预警'
                : scope.row.warnType == 2
                ? '租赁设备临期预警'
                : '设备滤芯余量预警'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="packageType" label="预警方式">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.packageType == 1
                ? '短信预警服务'
                : scope.row.packageType == 2
                ? '语音电话预警服务'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="关闭时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 添加关闭预警设备弹框 -->
    <el-dialog
      title="添加关闭预警设备"
      :visible.sync="dialogVisible"
      width="30%"
      top="45vh"
      center
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="设备编号" prop="num">
          <el-select
            v-model="addForm.num"
            clearable
            placeholder="请选择设备编号"
            filterable
          >
            <el-option
              v-for="v in numArr"
              :key="v.id"
              :label="v.equipmentNum"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关闭预警方式" prop="type">
          <el-checkbox-group v-model="addForm.type">
            <el-checkbox label="短信预警服务" name="type"></el-checkbox>
            <el-checkbox label="语音电话预警服务" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="addBtn('addForm')">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      addForm: {
        num: "",
        type: [],
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择需要关闭的预警方式",
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: "请选择设备编号",
            trigger: "change",
          },
        ],
      },
      dataInfo: null,
      numArr: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.dataInfo = this.$route.query.data;
    this.getList();
    this.getNum();
  },
  methods: {
    // 恢复
    recover() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      handleConfirm("确定恢复设备通信预警吗？", "info")
        .then(() => {
          this.$api.communication
            .closeRecover({ blackId: this.multipleSelection[0].id })
            .then((b) => {
              if (b.code === 200) {
                handleAlert("预警已恢复", "success");
                this.getList();
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    // 编号下拉
    getNum() {
      this.$api.communication.numPull().then((a) => {
        if (a.code === 200) {
          this.numArr = a.data;
        }
      });
    },

    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.communication
        .closeList({
          pageNum: this.page,
          pageSize: this.pageSize,
          warnType: this.dataInfo.warnType,
          equipmentNum: this.form.num,
          packageType: this.form.way,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    // 添加弹框添加按钮
    addBtn(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm(
            "预警关闭后可能无法及时了解设备运行状态，确认关闭吗？",
            "info"
          )
            .then(() => {
              let numName = "";
              this.numArr.forEach((v) => {
                if ((this.addForm.num = v.id)) {
                  numName = v.equipmentNum;
                }
              });
              let types = [];
              this.addForm.type.forEach((e) => {
                if (e == "短信预警服务") {
                  types.push(1);
                } else if (e == "语音电话预警服务") {
                  types.push(2);
                } else {
                  return;
                }
              });
              this.$api.communication
                .closeAdd({
                  equipmentId: this.addForm.num,
                  equipmentNum: numName,
                  types: types,
                  warnType: this.dataInfo.warnType,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("预警已关闭", "success");
                    this.dialogVisible = false;
                    this.getList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    add() {
      this.dialogVisible = true;
      this.addForm = {
        num: "",
        type: [],
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    reset() {
      this.form = {};
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
